module.exports = __webpack_public_path__ + "static/media/headquarter.9ee01ed7.svg";